export default function RemoveACStyles() {
  const formColumn = document.querySelector('.global-50-50-container-columns-column-form');

  if (formColumn && formColumn.dataset.useAcStyles && formColumn.dataset.useAcStyles === 'false') {
    const formContainer = formColumn.firstElementChild;
    if (formContainer) {
      let i = 0;
      let style = formContainer.querySelector('style');
      if (style) {
        style.remove();
        const btn = formContainer.querySelector('._form-content button');
        if (btn) {
          btn.classList.add('theme-button', 'theme-button--primary');
        }
      } else {
        const max = 30;
        const timer = setInterval(() => {
          style = formContainer.querySelector('style');
          if (style) {
            clearInterval(timer);
            style.remove();
            const btn = formContainer.querySelector('._form-content button');
            if (btn) {
              btn.classList.add('theme-button', 'theme-button--primary');
            }
          } else {
            i++;
            if (i >= max) clearInterval(timer);
          }
        }, 100);
      }
    }
  }
}